import numeral from "numeral";
function formatMetric(input) {
  return numeral(Math.round(input)).format("0,0");
}
export default formatMetric;
